import { createAction, getActionList } from './action-utils';
import {
  AUTOCOMPLETE_SEARCH_FAIL,
  AUTOCOMPLETE_SEARCH_START,
  AUTOCOMPLETE_SEARCH_SUCCESS,
  AUTOCOMPLETE_SEARCH_WITH_GOOGLE_START,
  GOOGLE_GET_PLACE_DETAILS,
} from './types';

const actions = {
  /**
   * It updates the state to { loading: true }
   */
  autocompleteSearchStart: () => createAction(AUTOCOMPLETE_SEARCH_START, {}),
  getAutocompleteOptionsWithGoogle: (query: string) =>
    createAction(AUTOCOMPLETE_SEARCH_WITH_GOOGLE_START, query),
  getPlaceDetails: (placeId: string) =>
    createAction(GOOGLE_GET_PLACE_DETAILS, placeId),
  autocompleteSearchSuccess: (data: any[]) =>
    createAction(AUTOCOMPLETE_SEARCH_SUCCESS, data),
  autocompleteSearchFail: () => createAction(AUTOCOMPLETE_SEARCH_FAIL, {}),
};

export default actions;

const actionList = getActionList(actions);

export type AutocompleteActionType = typeof actionList[number];
